module.exports = __webpack_public_path__ + "media/images/emblems/MorbioInferiore-coat_of_arms-3426594d321fd84fae914780e86d5080.svg";